<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_7154_23660)">
      <path d="M24 12C24 5.37264 18.6274 0 12 0C5.37264 0 0 5.37264 0 12C0 17.6275 3.87456 22.3498 9.10128 23.6467V15.6672H6.62688V12H9.10128V10.4198C9.10128 6.33552 10.9498 4.4424 14.9597 4.4424C15.72 4.4424 17.0318 4.59168 17.5685 4.74048V8.06448C17.2853 8.03472 16.7933 8.01984 16.1822 8.01984C14.2147 8.01984 13.4544 8.76528 13.4544 10.703V12H17.3741L16.7006 15.6672H13.4544V23.9122C19.3963 23.1946 24.0005 18.1354 24.0005 12H24Z" fill="#0866FF" />
      <path d="M16.7002 15.6682L17.3737 12.001H13.454V10.704C13.454 8.76624 14.2143 8.0208 16.1818 8.0208C16.7929 8.0208 17.2849 8.03568 17.5681 8.06544V4.74144C17.0314 4.59216 15.7196 4.44336 14.9593 4.44336C10.9493 4.44336 9.10087 6.33648 9.10087 10.4208V12.001H6.62646V15.6682H9.10087V23.6477C10.0292 23.8781 11.0002 24.001 11.9996 24.001C12.4916 24.001 12.9769 23.9707 13.4535 23.9131V15.6682H16.6997H16.7002Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_7154_23660">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
